import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const itemHelpers = createMultiStyleConfigHelpers([
  'container',
  'stage',
  'iconWithLine',
  'line',
  'label',
  'labelContainer',
]);

const ProgressIndicatorTheme = itemHelpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      width: '100%',
    },
    iconWithLine: {
      display: 'grid',
    },
    label: {
      lineHeight: '1.5rem',
      maxWidth: '8rem',
      overflow: 'hidden',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    labelContainer: {
      display: 'flex',
      justifyContent: 'center',
    },
    line: {
      flexGrow: '1',
    },
    stage: {
      display: 'flex',
      gap: '8',
    },
  },
  variants: {
    horizontal: {
      container: {
        flexDir: 'row',
      },
      iconWithLine: {
        gridTemplateColumns: '1fr 24px 1fr',
      },
      labelContainer: {
        flexDir: 'row',
      },
      line: {
        marginY: 'calc(.75rem - 1px)',
      },
      stage: {
        flexDir: 'column',
      },
    },
    vertical: {
      container: {
        flexDir: 'column',
      },
      iconWithLine: {
        gridTemplateRows: '24px 1fr',
        minHeight: '62px',
      },
      labelContainer: {
        flexDir: 'column',
        justifyContent: 'start',
      },
      line: {
        height: '100%',
        justifySelf: 'center',
      },
      stage: {
        flexDir: 'row',
      },
    },
  },
});

export default ProgressIndicatorTheme;
